export const apiBaseUrl = `${process.env.DIRECTUS_URL}`;
